import {
	PLG_Container,
	PLG_PercentPassed,
	PLG_ProgressLine,
	PLG_ProgressLineFill,
	PLG_TimeLabel,
	PLG_TimeStat,
	PLG_TimeStats,
	PLG_TimeValue,
} from "./ProgressLessonGroup.styled";
import { GrandChartGroupLessonStore } from "../../../../../../../../../stores/grand-charts/grand-chart-group-lesson.store";
import { ServiceName } from "../../../../../../../../../constants";
import { AnimatedPercent } from "../../../../../../../AnimatedPercent";
import { calculatePercent, getTimeFromMin } from "../../../../../../../../../helpers";
import { observer } from "mobx-react";
import { useStores } from "../../../../../../../../../stores";
import { AnimatedTime } from "../../../../../../../AnimatedTime/AnimatedTime";

interface ProgressLessonGroupProps {
	service: ServiceName;
	groupLessonStore: GrandChartGroupLessonStore;
}

export const ProgressLessonGroup = observer(({ service, groupLessonStore }: ProgressLessonGroupProps) => {
	const { statisticsStore } = useStores();

	const passedSeconds = statisticsStore.getByGroupLessonId(groupLessonStore.id);

	const totalSeconds = groupLessonStore.totalAllLessonsTime;
	const progressPercent = calculatePercent(totalSeconds, passedSeconds);

	return (
		<PLG_Container $service={service}>
			<PLG_PercentPassed>
				<AnimatedPercent value={progressPercent} delay={0.4} />
			</PLG_PercentPassed>

			<PLG_ProgressLine>
				<PLG_ProgressLineFill $progress={progressPercent} />
			</PLG_ProgressLine>

			<PLG_TimeStats>
				<PLG_TimeStat>
					<PLG_TimeLabel>Hours passed</PLG_TimeLabel>
					<PLG_TimeValue data-variant="passed">
						<AnimatedTime valueSeconds={passedSeconds} delay={0.2} />
					</PLG_TimeValue>
				</PLG_TimeStat>
				<PLG_TimeStat $align="right" $variant="remain">
					<PLG_TimeLabel>Hours remain</PLG_TimeLabel>
					<PLG_TimeValue>
						<AnimatedTime valueSeconds={totalSeconds} delay={0.2} />
					</PLG_TimeValue>
				</PLG_TimeStat>
			</PLG_TimeStats>
		</PLG_Container>
	);
});
